if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        // Amélioration de la recherche du cart-notification
        this.findCart();

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      findCart() {
        // Essayer de trouver le cart-notification ou cart-drawer
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        // Si pas trouvé immédiatement, essayer avec un intervalle
        if (!this.cart) {
          const findCartInterval = setInterval(() => {
            this.cart =
              document.querySelector("cart-notification") ||
              document.querySelector("cart-drawer");
            if (this.cart) {
              console.log("Cart found after interval:", this.cart);
              clearInterval(findCartInterval);
            }
          }, 50);

          // Arrêter de chercher après 2 secondes maximum
          setTimeout(() => {
            clearInterval(findCartInterval);
            if (!this.cart) {
              console.warn("Cart notification not found after 2 seconds");
            }
          }, 2000);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const loadingSpinner = this.querySelector(".loading__spinner");
        if (loadingSpinner) {
          loadingSpinner.classList.remove("hidden");
        }

        // S'assurer que le cart est trouvé
        if (!this.cart) {
          this.findCart();
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // Forcer l'utilisation du cart-notification même s'il n'est pas trouvé
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        } else {
          // Si pas de cart trouvé, ajouter les sections par défaut
          formData.append(
            "sections",
            "cart-notification-product,cart-icon-bubble"
          );
          formData.append("sections_url", window.location.pathname);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            // Supprimer la redirection - toujours utiliser le cart-notification
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    if (this.cart) {
                      this.cart.renderContents(response);
                    } else {
                      // Si pas de cart trouvé, essayer de le trouver et afficher la notification
                      this.findCart();
                      setTimeout(() => {
                        if (this.cart) {
                          this.cart.renderContents(response);
                        }
                      }, 100);
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.cart) {
                this.cart.renderContents(response);
              } else {
                // Si pas de cart trouvé, essayer de le trouver et afficher la notification
                this.findCart();
                setTimeout(() => {
                  if (this.cart) {
                    this.cart.renderContents(response);
                  }
                }, 100);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            if (loadingSpinner) loadingSpinner.classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
